'use strict'
import OrderTableByState from './OrderTableByState'

export default function OrderTableConsegnati() {
  return <OrderTableByState states={[3]} title="Ordini Consegnati" />
}
